import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Table from "react-bootstrap/Table";
import MultiSelectDropdown from "../../components/MultiSelectDropdown/MultiSelectDropdown";
import { getAllBrands, getAllCategories } from "../../services/userService";
import { getBrandsByProjectId } from "../../services/projectService";
import { useSelector } from "react-redux";
import "./HealthCard.scss";

export default function HealthCard() {
  const [healthTableData, setHealthTableData] = useState([]);
  const [filteredData, setFilteredData] = useState(healthTableData);
  const [alphabetFilter, setAlphabetFilter] = useState("");
  const [filterCategory, setFilterCategory] = useState([]);
  const [selectedFilterCategory, setSelectedFilterCategory] = useState([]);
  const alphabets = "abcdefghijklmnopqrstuvwxyz".split("");
  const selectedProjectId = useSelector(
    (state) => state.user.recentlyUsedProjectId
  );
  const fetchLatestProjectID = useSelector(
    (state) => state.user.isLatestProjectId
  )?.toString();

  const { projectInfo } = useSelector((state) => state.user);

  const filteredProjectId = Number(selectedProjectId || fetchLatestProjectID);
  const matchingProject = projectInfo?.project?.find(
    (item) => item.id === filteredProjectId
  );

  const getProjectName = matchingProject?.project_name || "Unknown Project";

  const navigate = useNavigate();

  const fetchHealthCardData = async () => {
    const payload = selectedProjectId || fetchLatestProjectID;

    if (!payload) {
      console.warn("No project ID available to fetch health card data.");
      return;
    }

    try {
      const healthCardData = await getBrandsByProjectId(payload);

      if (healthCardData) {
        setHealthTableData(healthCardData);
        setFilteredData(healthCardData);
      }
    } catch (error) {}
  };

  useEffect(() => {
    let filtered = healthTableData;

    // Clear alphabet filter when category is selected
    if (selectedFilterCategory.length > 0) {
      setAlphabetFilter(""); // Clear alphabet filter when a category is selected
    }

    // Alphabet filter
    if (alphabetFilter !== "") {
      filtered = filtered.filter((item) =>
        item.brand_name
          ?.toLowerCase()
          ?.startsWith(alphabetFilter?.toLowerCase())
      );
    }

    // Category filter
    if (selectedFilterCategory.length > 0) {
      const selectedCategoryNames = selectedFilterCategory.map(
        (option) => option.label
      );
      filtered = filtered.filter((item) => {
        const itemCategory = item.category_name ? item.category_name : "";
        return selectedCategoryNames.includes(itemCategory);
      });
    }

    setFilteredData(filtered);
  }, [alphabetFilter, selectedFilterCategory, healthTableData]);

  const fetchAllBrands = async () => {
    try {
      const brandsData = await getAllBrands();
    } catch (error) {}
  };

  // const fetchAllCategories = async () => {
  //   try {
  //     const categoriesData = await getAllCategories();
  //     setFilterCategory(
  //       categoriesData?.data?.map((cat) => ({
  //         value: cat.id,
  //         label: cat.name,
  //       }))
  //     );

  //   } catch (error) {}
  // };

  const handleAlphabetClick = (alphabet) => {
    setAlphabetFilter(alphabet);
  };

  const handleCategoryFilter = (selectedOptions) => {
    setSelectedFilterCategory(selectedOptions);
  };

  const handleRowClick = (row) => {
    navigate(
      `/healthcardOverview/${row?.brand_name}/${
        selectedProjectId || fetchLatestProjectID
      }`
    );
  };
  const columns = [
    {
      header: "S.no",
      accessor: "Serial_no",
    },
    { header: "Brands", accessor: "brand_name" },

    { header: "Category", accessor: "category_name" },
  ];
  useEffect(() => {
    const fetchCategoriesByProjectId = async () => {
      if (!projectInfo) return;

      const categoriesList = Array.isArray(matchingProject?.categoryNames)
        ? matchingProject.categoryNames.map((cat) => ({
            value: cat,
            label: cat,
          }))
        : [];
      setFilterCategory(categoriesList);
    };
    fetchCategoriesByProjectId();
  }, [projectInfo, selectedProjectId, fetchLatestProjectID]);

  useEffect(() => {
    fetchAllBrands();
    // fetchAllCategories();
    fetchHealthCardData();
  }, []);
  useEffect(() => {
    fetchHealthCardData();
  }, [fetchLatestProjectID, selectedProjectId]);

  return (
    <div className="col-12">
      <div className="workspace-container">
        <div className="healthcard-heading">
          <h2 className="page-title ml-3">Health Card</h2>
          {/* <span className="projectName">Project name: {getProjectName}</span> */}
          <div className="category-filter">
            <MultiSelectDropdown
              options={filterCategory}
              selectedValues={selectedFilterCategory}
              onChange={handleCategoryFilter}
              placeholder="Select Categories"
            />
          </div>
        </div>

        <ul className="alphabet-filters">
          {alphabets.map((alphabet, index) => (
            <li
              key={index}
              // className={filter === alphabet ? "active" : ""}
              onClick={() => handleAlphabetClick(alphabet)}
            >
              {alphabet}
            </li>
          ))}
          <li onClick={() => setAlphabetFilter("")}>
            <button className="clearBtn">Clear Filter</button>
          </li>
        </ul>
        <div className="row justify-content-center">
          <div className="col-md-12 col-lg-8 healthcard mt-3">
            <div className="rounded-3 overflow-hidden shadow">
              <Table responsive hover>
                <thead>
                  <tr>
                    <th style={{ width: "80px" }}>S.No</th>
                    <th>Brand</th>
                    <th>Category</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData &&
                    filteredData.length > 0 &&
                    filteredData?.map((item, index) => {
                      return (
                        <tr key={index} onClick={() => handleRowClick(item)}>
                          <td style={{ width: "80px" }}>{index + 1}</td>
                          <td>{item.brand_name}</td>
                          <td>{item.category_name}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
